import { AppModel as AppModelBase, BoneTypeEnum, LayerElementsBase, NextRayMeasures as NextRayMeasuresBase, SelectedApexMech } from '@ortho-next/nextray-core';
import { Context } from "../States/Context";
import { OsteotomyCut, StateDescription } from "../States/State";
import { PrintResult } from "../Utils/PrintUtils";
import { PlateModel } from "./PlateModel";

export interface BOM {
	screwNoLockingList?: number[];
	screwLockingList?: number[];
}

export enum PlateOrientationType {
	lateral,
	medial
}

export interface NextRayMeasures extends NextRayMeasuresBase, NextrayMeasuresEoCMech { }


export interface NextrayMeasuresEoCMech {
	eoc_ap_LPFA?: number;
	eoc_ap_mLDFA?: number;
	eoc_ap_MPTA?: number;
	eoc_ap_LDTA?: number;
	eoc_ap_JLCA?: number;
	eoc_ap_MAD?: number;
	eoc_ap_MNSA?: number;
	eoc_ap_MPFA?: number;
	eoc_ap_aLDFA?: number;
	eoc_ap_kneeTranslation?: number;
	eoc_ap_femurLength?: number;
	eoc_ap_tibiaLength?: number;
	eoc_ap_fullLength?: number;

	eoc_lt_PDFA?: number;
	eoc_lt_PPTA?: number;
	eoc_lt_ADTA?: number;
	eoc_lt_kneeTranslation?: number;

	eoc_ap_angle?: number;
	eoc_lt_angle?: number;
	eoc_ap_cortexLength?: number;
	eoc_lt_cortexLength?: number;
	eoc_ap_axialLength?: number;
	eoc_lt_axialLength?: number;
	eoc_ap_secondaryTransl?: number;
	eoc_lt_secondaryTransl?: number;
}

export interface LayerElements extends LayerElementsBase {
	mechanicalAxis_anatomical?: boolean;
	mechanicalAxis_mechanical?: boolean;
	mechanicalAxis_weightBearing?: boolean;
	contralateral_all?: boolean;
	osteotomy?: boolean;
	plate?: boolean;
}

/**
 * Model used by angular to create bindings. Only three.js part can set this values.
 */
export class AppModel extends AppModelBase {
	protected declare _context: Context;
	public declare measures: NextRayMeasures; //override
	public declare layers: LayerElements; //override
	public declare layersValue: LayerElements; //override
	public declare selectedApex: SelectedApexMech; //override

	/**
	 * Indicates if the plate is inserted.
	 */
	public isPlateInserted = false;
	/**
	 * Gets the selected osteotomy cut to perform.
	 */
	public osteotomyCut!: OsteotomyCut;
	/**
	 * Indicates if EoC cut switch is on/off.
	 */
	public eocCut!: boolean;
	/**
	 * Gets the plate orientation.
	 */
	public plateOrientation = PlateOrientationType.lateral;
	/**
	 * Gets selected plate model data.
	 */
	public plate: PlateModel | undefined;
	/**
	 * Indicates if it's loading AP plate mesh.
	 */
	public isAPPlateLoading!: boolean;
	/**
	 * Indicates if it's loading lateral plate mesh.
	 */
	public isLTPlateLoading!: boolean;
	/**
	 * Gets BOM data.
	 */
	public screwsBom!: BOM;
	/**
	 * Gets images for print report.
	 */
	public printResult?: PrintResult;
	/**
	 * Gets images to use in zoomed popup during calibration.
	 */
	public declare magnifier?: string;
	/**
	 * Gets ostoetomy level measure for print report.
	 */
	public print_osteotomyLevel = 0;
	/**
	 * Gets cortex wire measure for print report.
	 */
	public print_cortexWire = 0;
	/**
	 * Gets wire angle measure for print report.
	 */
	public print_wireAngle = 0;
	/**
	 * Gets bone type of Lateral view.
	 */
	public boneTypeLT!: BoneTypeEnum;

	public override get stateDescription(): StateDescription {
		return super.stateDescription;
	}
}
